import type {BusinessCustomPropertiesDefinitionsPagePayload} from '@github-ui/custom-properties-types'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import {useCallback, useState} from 'react'

import {useListPropertiesPath} from './use-properties-paths'

interface Props {
  initialPayload: BusinessCustomPropertiesDefinitionsPagePayload
}

export function useBusinessPropertiesListResults({initialPayload}: Props) {
  const path = useListPropertiesPath()

  const [currentPage, setCurrentPage] = useState(1)
  const [payload, setPayload] = useState(initialPayload)

  const fetchResults = useCallback(
    async ({page, filterQuery}: {page: string | number; filterQuery: string}) => {
      setCurrentPage(Number(page))

      const fetchParams = new URLSearchParams({page: page.toString(), q: filterQuery})
      const fetchUrl = `${path}?${fetchParams.toString()}`

      try {
        const response = await verifiedFetchJSON(fetchUrl)
        const data = (await response.json()) as {payload: BusinessCustomPropertiesDefinitionsPagePayload}
        setPayload(data.payload)
        window.scrollTo({top: 0})
      } catch {
        // Do nothing
      }
    },
    [setCurrentPage, path],
  )

  return {currentPage, payload, fetchResults}
}
